import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import { useDomainConfig } from "src/hooks/useDomainConfig";
import { useState, useEffect, useRef } from "react";

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  const domainConfig = useDomainConfig();
  const [status, setStatus] = useState("loading");
  const [logoUrl, setLogoUrl] = useState(null);
  const isMountedRef = useRef(true);

  const fallbackLogo = "logo/amikCharge.svg";

  useEffect(() => {
    if (domainConfig.logoUrl) {
      setLogoUrl(domainConfig.logoUrl);
      setStatus("loading");
      
      const img = new Image();
      img.src = domainConfig.logoUrl;
      img.onload = () => {
        if (isMountedRef.current) {
          setStatus("success");
        }
      };
      img.onerror = () => {
        if (isMountedRef.current) {
          setStatus("error");
        }
      };
    }
  }, [domainConfig.logoUrl]);

  // Cleanup effect to prevent memory leaks
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Don't show loading if we already have a logo URL and it's just refreshing
  if (!logoUrl) {
    return (
      <Box sx={{ width: "70%", height: 40, margin: "auto", ...sx }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (status === "error") {
    return (
      <Box
        component="img"
        src={fallbackLogo}
        sx={{ width: "70%", margin: "auto", ...sx }}
        alt=""
      />
    );
  }

  return (
    <Box
      component="img"
      src={logoUrl}
      sx={{
        width: "70%",
        margin: "auto",
        opacity: status === "success" ? 1 : 0.7, // Show with reduced opacity while loading
        transition: "opacity 0.3s ease-in-out",
        ...sx,
      }}
      alt=""
      onLoad={() => {
        if (isMountedRef.current) {
          setStatus("success");
        }
      }}
      onError={() => {
        if (isMountedRef.current) {
          setStatus("error");
        }
      }}
    />
  );
}
